module.exports = __webpack_public_path__ + "assets/img/xinjianghua_519_4.ec2c4679.jpg";